export default __webpack_public_path__ + "static/media/undraw_Setup_re_y9w8.2e78ce80.svg";